/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import * as React from 'react'
import { useIntl } from 'react-intl'
import classnames from 'classnames'
import ThirdPartyButton from './thirdPartyButton'
import { AccountMethod } from '../../services/mixpanelService'
import { StyledThirdPartyButtons } from './styles'

interface IIdentityProviders {
  href: string
  img: string
  providerName: string
  disabledImg: string
}

interface ThirdPartyButtonsProps {
  className?: string
  mode?: 'horizontal' | 'vertical'
  type: 'login' | 'create'
  providers: IIdentityProviders[]
  disabled?: boolean
}

const ThirdPartyButtons = (props: ThirdPartyButtonsProps) => {
  const intl = useIntl()
  const { type, providers = [], className, mode = 'vertical', disabled } = props

  const formatName = providerName => {
    switch (providerName) {
      case 'Office365':
        return AccountMethod.MICROSOFT
      case 'SignInWithApple':
        return AccountMethod.APPLE
      case 'Google':
      default:
        return AccountMethod.GOOGLE
    }
  }

  const getProviderText = (provider: string): string => {
    if (mode === 'vertical') {
      return intl.formatMessage({
        id: `${type}.${formatName(provider).toLocaleLowerCase()}`,
      })
    }
    return formatName(provider)
  }

  return (
    <StyledThirdPartyButtons
      className={classnames('ThirdPartyButtons-root', { 'ThirdPartyButtons-row': mode === 'horizontal' }, className)}
    >
      {providers.map((provider: IIdentityProviders) => {
        const { href, img, disabledImg, providerName } = provider
        return (
          img && (
            <ThirdPartyButton
              type={type}
              disabled={disabled}
              key={providerName}
              method={formatName(providerName)}
              text={getProviderText(providerName)}
              icon={disabled ? disabledImg : img}
              url={href}
              align={mode === 'horizontal' ? 'vertical' : 'row'}
            />
          )
        )
      })}
    </StyledThirdPartyButtons>
  )
}

export default ThirdPartyButtons
